/*eslint-disable*/
export default productPage => {
	const hiddenNodes = productPage.querySelectorAll('.js-lazy-load-pdp')
	$(window).load(() => window.loaded = true)
	$(window).bind('load.lazy scroll.lazy resize.lazy', () => {
		hiddenNodes.forEach(hiddenNode => loadMedia(hiddenNode))
	})

	const loadMedia = node => {
		if (node) {
			let trackerArr = [];
			let nodeMedia = node.querySelectorAll('.js-lazy-load-media')
				if ($(window).scrollTop() + $(window).height() + 300 >= $(node).offset().top && !$(node).hasClass('loaded')) {
					nodeMedia.length
						? nodeMedia.forEach((content, i) => {						
							$(content).on("load", () => {
								trackerArr.push(i)
								trackerArr.length === nodeMedia.length && $(node).addClass('loaded')
							})
							if(!$(content).hasClass('loaded')){
								$(content).hasClass('video-source')
								? window.loaded && $(content).attr('src', $(content).data('video-src')) && $(content).closest('video').load().closest('.js-lazy-load-module').addClass('loaded') && $(content).addClass('loaded')
								:	content.src = $(content).data('image-src')
							}
						})
						: $(node).addClass('loaded')
				}
			if ($(window).scrollTop() + $(window).height() - 200 >= $(node).offset().top && !$(node).hasClass('visible')) {
				$(node).hasClass('video-container')
				? $(node).hasClass('loaded') && $(node).css({ 'opacity': 1 }).addClass('visible')
				: $(node).hasClass('loaded') && $(node).css({ 'opacity': 1, 'top': 0 }).addClass('visible')
			}
		}
	}
}




// WEBPACK FOOTER //
// ./src/scripts/components/lazy-load-pdp.js